import { React, useEffect, useState, useRef, useCallback } from "react";
import { useStore, useStoreApi } from '@hmpu/powerups.store';
import { useTranslation } from '@hmpu/powerups.intl.hooks.use-translation';
import { useTranslate } from '@hmpu/powerups.intl.legacy.hooks.use-translate';
import { useSkipChapter } from '@hmpu/powerups.vie.hooks.use-skip-chapter';
import { useVieConfig } from '@hmpu/powerups.vie.hooks.use-vie-config';
import "./GamePlay.css";
import { CTAButton } from '@hmpu/powerups.ui.buttons.cta-button';
import AriaLiveAnnoucer from '../../components/AriaLiveAnnoucer';
import { usePrevious } from '@hmpu/powerups.hooks.use-previous';
import { globalizedMedia } from '@hmpu/powerups.intl.hooks.use-localized-media';
// import Countdown from "./Countdown";

import SequenceButton from "./SequenceButton";
import { useLottie } from "lottie-react";

import useVolumeControl from "../../components/Audio/hooks/useVolumeControl";

import "@lottiefiles/lottie-player";
import { create } from "@lottiefiles/lottie-interactivity";
import lottie from "lottie-web";
import useResetFocus from '../../hooks/useResetFocus';
import { size, update } from "lodash";
import HeaderH1 from "../../components/Promo";

import SparkAnimation from "../../components/SparkAnimation/SparkAnimation";
// import { match } from "assert";

// @2DO: Make debug mode build script to remove debug conditionals from codebase for performance 


const matchSequence = {
  gameTemplate: {
    // machine-name: a2hawuidfhie1ha12`3129821,
    // slug: "the-little-mermaid",
    model: "wbdc", //  "tlm||marvels||d100||nitro||petsim",
    enableCountDown: false,
    actionType: "vie", // "turn || live || vie", 
    errorOnMissImmediately: false, // D100 has no error state
    initialSequenceLength: 1, // D100 always has a sequence.length of 1
    sequenceType: "vieCue", // "random || incrementing || vieCue || subtractive", // @2DO: etc.
    completeSequenceAt: 1, // D100 always has a sequence.length of 1 
    // mustCompleteSequence: true, // D100 has matching sequence trigger toy sprite + gameplay sprite 
    omniButton: false, // D100 has one button to match all three seqeuence slugs 
    // streakCounts: [3,6,9], // @2D): New functionality -> triggers handler 
      // array of turns can be evaluated for hit / miss totals 
    // winCondition: "cue:completion_or_whatever", // D100 has no way to win or lose – song controls length of experience
    // winCount = 2; // @2DO: Finished all the levels? 
    buttonsUseLotties: false, // @2DO: usesLottieButtons
    buttonsUseSFX: false, 
    streaksUseSpriteBackgrounds: true,
    streaksUseToySprites: false,
    spriteVerticalOffsetMinimum: 5,
    // @2DO: repeatSequence ... 
    // praise words use incremental ordering based on total 
    useRenderedSpriteCSSFiles: true,
    renderSpriteCSSFilesEarly: false,
    // renderSprites: true,
    renderSpritesAsBase64: false, // @2DO: This renders style tags, move to build script
    prefetchSpritePng: false, // @2DO: This doesn't work, the browser re-fetches the pngs 
    // useSpriteComponent: false, // @2DO: Use a web component for sprites instead of native dom elements, not recommended
    // useCountdownOverlay: false, // @2DO: Use Countdown component to render countdown using elements 
    debugMode: false,
    debugHits: false,
    debugToyHits: false,
    debugStreaks: false,
    loopSprites: false,
    preloadSpritesAsImgTag: false,
    removeSpritesOnAnimationEnd: true,
    levelsDontUseCssToySprites: [],
    elemsToDestroyOnExit: ['#spriteElem', '#spriteToyElem', '#game-pads'],
    hitAnimationDurationModifier: 1,
    useGifImg: [],
    garbageTimeout: 3000, // Time before sprites are removed from the DOM – CAN CAUSE ISSUES 
    spritesToLoad: ['hit-0','hit-1','hit-2','hit-3','toy-hit','streak-anim'], // ['hit-1','hit-2','hit-3','toy-hit','toy-streak'],
    useStaticToyArea: true,
    usePauseTimeoutToRestartGame: true,
  },
};

// @2DO: Move this to build script.
// base64 encodes all pngs in dir/subdirs/ in .txt files with the same name 
// find . -name "*.png" -exec bash -c "base64 -i {} > {}.txt" \;

// find . -name "*.png" -exec mogrify -resize 300x  {} + 


// export const Game = ({ currentKey, soundEffects }) => {
export const Game = ( props ) => {

  const gameLevel = useStore((state) => state.gameLevel);

  // let toyHitData = new Image();
  // toyHitData.src = `${process.env.PUBLIC_URL}/static/media/global/anim/sprites/gameLevel${gameLevel}/toy-hit-0.gif`;
  // useEffect(() => {
  //   console.log('toyHitData: ', toyHitData);
  // }, [])

  const { soundEffectsRef } = props;
  // console.log('currentKey: ', currentKey);
  // console.log("levelConfig", levelConfig);

  // console.log('soundEffectsRef: ', soundEffectsRef);

  // let soundEffects = { 
  //   current: soundEffectsRef.current,
  //   player: 
  // };

  const metadataTrack = useStore((state) => state.metadataTrack);
  const handleCues = function() {
    const output = {
      titles: [],
      hits: 0
    };
    // console.log(metadataTrack);
    console.log(metadataTrack?.cues);
    console.log('metadataTrack?.cues.length', metadataTrack?.cues.length);
    if (metadataTrack?.cues.length > 0) {
      for (let i = 0; i < metadataTrack.cues.length; i++) {
        const cue = metadataTrack.cues[i];
        console.log('cue.id: ', cue.id);
        output.titles.push(cue.id);
        if (cue.id.includes('_HIT_')) {
          output.hits++;
        }
      }
    }
    console.log(output);
    return output;
  };

  const [ history, setHistory ] = useState([]);
  const playthrough = {};
  const [ completionMark, setCompletionMark ] = useState(null);

  const currentCueMetadata = useStore((state) => state.currentCueMetadata);


  const urlParams = new URLSearchParams(window.location.search);
  const skip = useRef([]);
  const cheat = useRef(false);

  const translate = useTranslate();

  const endScreenOutroSprite = globalizedMedia(translate('endScreenOutroSprite', "END_GAME"), 'img');


  // pick random intro & outro sprites for end_screen
  const endGameResults = translate('results', 'END_GAME');
  const endScreenAnimationAriaLabel = translate('results', 'END_GAME').ariaLabel;
  const introResults = endGameResults.intro;
  const outroResults = endGameResults.outro;
  const [endScreenIntro, setEndScreenIntro] = useState();
  const [endScreenIntroSlug, setEndScreenIntroSlug] = useState();
  const [endScreenIntroLabel, setEndScreenIntroLabel] = useState();
  const [endScreenOutro, setEndScreenOutro] = useState();
  const [endScreenOutroLabel, setEndScreenOutroLabel] = useState();
  const [endScreenWrapupVisible, setEndScreenWrapupVisible] = useState();

  useEffect(() => {
        const levelMapping = ["spawn", "tech", "kawaii"];
        const currentLevel = levelMapping[gameLevel];

        const filteredResultsIntros = introResults.filter(egg => egg.level.includes(currentLevel));
        const filteredResultsOutros = outroResults.filter(char => char.level.includes(currentLevel));


        if (filteredResultsIntros.length > 0 && filteredResultsOutros.length > 0) {
          let introIndex = Math.floor(Math.random() * filteredResultsIntros.length);
          let outroIndex = Math.floor(Math.random() * filteredResultsOutros.length)

          // Override random results with url param in testing mode
          if (urlParams.get('testing') === 'true') {
            console.log('TESTING: true');
            if (urlParams.get('results-intro') && urlParams.get('results-outro')) {

              introIndex = parseInt(urlParams.get('results-intro'));
              outroIndex = urlParams.get('results-outro');
            }
          }

          const chosenIntro = filteredResultsIntros[introIndex];
          const chosenChar = filteredResultsOutros[outroIndex];
          setEndScreenIntroSlug(chosenIntro.slug);
          setEndScreenIntroLabel(chosenIntro.label);
          setEndScreenIntro(`results-intro-${introIndex + 1}`); 
          setEndScreenOutroLabel(chosenChar.label);
          setEndScreenOutro(chosenChar.slug);

          // !matchSequence.gameTemplate.spritesToLoad.includes(chosenIntro.slug) && matchSequence.gameTemplate.spritesToLoad.push(chosenIntro.slug);
          !matchSequence.gameTemplate.spritesToLoad.includes(`results-intro-${introIndex + 1}`) && matchSequence.gameTemplate.spritesToLoad.push(`results-intro-${introIndex + 1}`);

        }

  }, []);

  // useEffect(() => {
  //   console.log("INTRO ANIM ------------------- : ", endScreenIntro);
  //   console.log("OUTRO ANIM ------------------- : ", endScreenOutro);

  //   if(endScreenIntro) {
  //     matchSequence.gameTemplate.spritesToLoad.push(endScreenIntro);
  //   }
  // }, [endScreenIntro, endScreenOutro])

  useEffect(() => {
    // @2DO: Normalize the game init conditions in wrapper component 
    //console.log('levelConfig: ', levelConfig);*/

    handleRenderSprites();

    if (urlParams.get('cheat') === 'true') {
      cheat.current = true;
    }
    cheat.current && console.log('cheat.current', cheat.current);

    
    if (urlParams.get('skipToEnd') === "true") {
      const completion = urlParams.get('completion') ? urlParams.get('completion') : 0;
      urlParams.delete('skipToEnd');
      window.history.replaceState(null, null, '?' + urlParams.toString());
      handleMiss();
      skip.current.push('CHAPTER_COMPLETION_' + completion);
    } else if (urlParams.get('skipTo') === 'GAMEPLAY') {
      skip.current.push('CHAPTER_GAMEPLAY');
      console.log('skip: ', skip);
      initGame(matchSequence.gameTemplate);
      setTimeout(() => {
        updateVieConfig({ 
          ...levelConfigShared, 
          skipChapter: 'CHAPTER_COUNTDOWN',
          forceUpdate: true
        });
      }, 1000);
      document.getElementById('game-pads').setAttribute('data-visible','true');
      urlParams.delete('skipTo');
      window.history.replaceState(null, null, '?' + urlParams.toString());
    } else {
      // Start the game up without any override
      updateVieConfig({ ...levelConfigShared, forceUpdate: false });
      //incrementSequence(turnNext);
    }
    
    document.querySelector('.game-wrapper').setAttribute('data-level',gameLevel);

    document.getElementsByTagName('html')[0].setAttribute('data-debug-mode', matchSequence.gameTemplate.debugMode);

    // setInterval(() => {
    //   // console.log('GAME: VIE: currentTime: ', document.querySelector('.interface-video-player').currentTime);
    //   // document.getElementById('vie-debugger').innerText = document.querySelector('.interface-video-player').currentTime;
    //   // document.getElementById('vie-debugger-cue').innerText = currentCueMetadata?.id;
    // }, 20);    

  }, []);

  const parentNode = 'GAME_SEQUENCE';
  const { subscribe } = useStoreApi();
  const isPauseEnabled = useStore((state) => state.isPauseEnabled);
  // const setPlay = useStore((state) => state.setPlay);  

  // spark animation
  const gameLevelToFrameCount = {
    0: 17,
    1: 17, 
    2: 17
  };  

  const toyAreaHitFrameCount = {
    0: 36,
    1: 29,
    2: 29
  };

  const toyAreaStreakFrameCount = {
    0: 36,
    1: 29,
    2: 29
  }

  function getArbitrary(min, max) {
    return Math.random() * (max - min) + min;
  }
  function getArbitraryInt(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
  }
  function getArbitraryRGBA(minR, maxR, minG, maxG, minB, maxB, min, max) {
    const getRGBA = 'rgba(' + getArbitrary(minR,maxR) + ',' + getArbitrary(minG,maxG) + ',' + getArbitrary(minB,maxB) + ',' + getArbitrary(min,max) + ')';
    return getRGBA;
  }
  function getRandomRGB() {
    const getRGBA = `rgba(${getArbitrary(0,255)},${getArbitrary(0,255)},${getArbitrary(0,255)},${getArbitrary(0.9,0.95)})`;
    return getRGBA;
  }

  const generateKeyframes = (imageData, spriteKey) => {
    // if (imageData === null) { console.log('not using base64 imports'); }
    if (matchSequence.gameTemplate.useRenderedSpriteCSSFiles === false) {
      // const path = (gameLevel === 1) ? `${process.env.PUBLIC_URL}/static/media/global/anim/sprites/gameLevel0/${spriteKey}/` : `${process.env.PUBLIC_URL}/static/media/global/anim/sprites/gameLevel${gameLevel}/${spriteKey}/`;
      const path = `${process.env.PUBLIC_URL}/static/media/global/anim/sprites/gameLevel${gameLevel}/${spriteKey}/`;
      let frameCount = 0;
      if (spriteKey.split('-')[0] === 'hit') {
        frameCount = gameLevelToFrameCount[gameLevel] || 60;
      } else if (spriteKey.split('-')[1] === 'streak') {
        // Assume toy-streak
        frameCount = toyAreaStreakFrameCount[gameLevel] || 60;
      } else {
        // Assume toy-hit
        frameCount = toyAreaHitFrameCount[gameLevel] || 60;
      }
      const step = 100 / (frameCount - 1);
      let frames = '';
      for (let i = 0; i < frameCount; i++) {
        let tileName = 'tile';
        if (i.toString().length < 2) {
          tileName += '00' + i;
        } else if (i.toString().length < 3) {
          tileName += '0' + i;
        }
        if (matchSequence.gameTemplate.renderSpritesAsBase64 === false) {
          frames += `
          ${(i * step).toFixed(5)}% {
            /*background-color: ${getRandomRGB()};*/
            background-image: url(${path}${tileName}.png);
          }
          `;
        } else if (matchSequence.gameTemplate.renderSpritesAsBase64 === true) {
          frames += `
          ${(i * step).toFixed(5)}% {
            background-image: url("data:image/png;base64,${imageData[i]}"); 
          }
          `;
        } 
      }
      
      const animationName = `@keyframes ${spriteKey} { ${frames} }`;
      // const animationKey = 'hit-' + variant;
      const styleSheet = document.createElement('style');
      styleSheet.type = 'text/css';
      document.querySelector('head').append(styleSheet);
      // console.log(animationName);
      styleSheet.appendChild(document.createTextNode(animationName));
      // console.log(styleSheet);
      // styleSheet.insertRule(animationName, styleSheet.cssRules.length);
      console.log('SPRITE CSS:' + spriteKey + ' : styleSheet: ', styleSheet);
    }
  };


  const [streakHeader, setStreakHeader] = useState('');
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    if (streakHeader) {
        setFadeOut(false);
        setTimeout(() => {
            setFadeOut(true);
        }, 500);
    }
}, [streakHeader]);

  const exemptClasses = ['ui-buttons-circle-button', 'primary-cta-btn', 'pause-btn-list'];
  const removalTimers = useRef([]);
  const [clicks, setClicks] = useState([]);
  const [imageDataPx, setImageDataPx] = useState([]);
  const [imageDataPy, setImageDataPy] = useState([]);
  const [imageDataPz, setImageDataPz] = useState([]);
  const [toyAreaHitSpriteData, setToyAreaHitSpriteData] = useState([]);
  const [toyAreaStreakSpriteData, setToyAreaStreakSpriteData] = useState([]);
  const [position, setPosition] = useState('center'); 

  const [activeElem, setActiveElem] = useState(document.activeElement);

  useEffect(() => {
    const handleBlur = () => {
      setActiveElem(null);
    };
    const handleFocus = () => {
      setActiveElem(document.activeElement);
    };

    window.addEventListener('blur', handleBlur);
    window.addEventListener('focus', handleFocus);
  
    return () => {
      window.removeEventListener('blur', handleBlur);
      window.removeEventListener('focus', handleFocus);
    };
  }, []);

  const setIsPauseEnabled = useStore((state) => state.setIsPauseEnabled);
  // useEffect(() => {
  //   if (currentCueMetadata?.id && currentCueMetadata.id.includes("TRIGGER_HIT")) {
  //       const match = currentCueMetadata.id.match(/TRIGGER_HIT_(\d+)/);
  //       console.log("%c MATCH -------- ","color: blue; font-family:monospace; font-size: 40px", match);
  //       if (match) {
  //           const triggerValue = match[1];
  //           console.log("Extracted triggerValue:", triggerValue);
  //           setPosition(triggerValue);
  //       } else {
  //           console.log("Regex did not match");
  //       }
  //   } else {
  //       console.log("currentCueMetadata.id doesn't include TRIGGER_HIT or doesn't exist");
  //   }
  // }, [currentCueMetadata]);

  useEffect(() => {
    console.log("%c POSITION-------- ","color: yellow; font-family:monospace; font-size: 40px", position);
  }, [position]);

//   useEffect(() => {

//     if ((matchSequence.gameTemplate.prefetchSpritePng === true || matchSequence.gameTemplate.useRenderedSpriteCSSFiles === false) && matchSequence.gameTemplate.renderSpritesAsBase64 === true) {

//       console.log('FETCHING: SPRITES');

//       const fetchImageData = async (folderName) => {
//         const frameCount = gameLevelToFrameCount[gameLevel] || 60;
//         const promises = [];
//           for (let i = 1; i <= frameCount; i++) {
//             let tileName = 'tile';
//             if (i.toString().length < 2) {
//               tileName += '00' + i;
//             } else if (i.toString().length < 3) {
//               tileName += '0' + i;
//             }
//             let spriteFileType = '.png';
//             (matchSequence.gameTemplate.prefetchSpritePng === false) && (spriteFileType = '.png.txt');
//             const promise = fetchImage(folderName, tileName + spriteFileType);
//             promises.push(promise);
//           }

//           return Promise.all(promises);
//       };

//       fetchImageData(`static/media/global/anim/sprites/gameLevel${gameLevel}/hit-1`)
//       .then(data => {
//         setImageDataPx(data);
//         generateKeyframes(data, 'hit-1');
//       })
//       .catch(error => console.error('Error loading hit-1 image data:', error));

//       fetchImageData(`static/media/global/anim/sprites/gameLevel${gameLevel}/hit-2`)
//       .then(data => {
//         setImageDataPy(data);
//         generateKeyframes(data, 'hit-2');
//       })
//       .catch(error => console.error('Error loading hit-2 image data:', error));

//       fetchImageData(`static/media/global/anim/sprites/gameLevel${gameLevel}/hit-3`)
//       .then(data => {
//         setImageDataPz(data);
//         generateKeyframes(data, 'hit-3');
//       })
//       .catch(error => console.error('Error loading hit-3 image data:', error));

//       fetchImageData(`static/media/global/anim/sprites/gameLevel${gameLevel}/toy-hit`)
//       .then(data => {
//         setToyAreaHitSpriteData(data);
//         generateKeyframes(data, 'toy-hit');
//       })
//       .catch(error => console.error('Error loading toy-hit image data:', error));

//       fetchImageData(`static/media/global/anim/sprites/gameLevel${gameLevel}/toy-streak`)
//       .then(data => {
//         setToyAreaStreakSpriteData(data);
//         generateKeyframes(data, 'toy-streak');
//       })
//       .catch(error => console.error('Error loading toy-streak image data:', error));

//     }
// }, [gameLevel]); 

    // const fetchImage = async (folderName, imageName) => {
    //     try {
    //         console.log('fetching: ', `${process.env.PUBLIC_URL}/${folderName}/${imageName}`);
    //         const response = await fetch(`${process.env.PUBLIC_URL}/${folderName}/${imageName}`);
    //         const textData = await response.text();
    //         return textData.replace('data:image/png;base64,', '').replace('\n','');
    //     } catch (error) {
    //         console.error(`Error fetching image from ${folderName}:`, error);
    //         throw error;
    //     }
    // };

    // const isElementExempted = (target) => {
    //   while (target) { 
    //     if (exemptClasses.some(exemptClass => target.classList.contains(exemptClass))) {
    //       return true;
    //     }
    //     target = target.parentElement;
    //   }
    //   return false;
    // };

/**
 * Set the initial level
 */
  const gameCharacter = useStore((state) => state.gameCharacter);

  const levels = translate('levels', 'GAME_PLAY');
  const availableStreaks = translate('streaks', 'GAME_PLAY');
  const levelConfigShared = levels[gameLevel].vieConfig;
  const getRandomLevel = () => { return Math.floor(Math.random() * levels.length)};
  const [ currentLevelIndex, setCurrentLevelIndex] = useState(gameLevel); // (getRandomLevel()); // @2DO: This should respect a flag 
  const [ previousLevelIndex, setPreviousLevelIndex] = useState(currentLevelIndex); 
  const [ levelConfig, setLevelConfig] = useState(levels[currentLevelIndex]); 
  const selectedLevel = levelConfig; // @2DO: This is unnecessary 

  const tutorialContent = {
    main: translate('tutorial', 'GAME_PLAY'),
    axe: levels[gameLevel].tutorial_hidden
  };

  const gameInstructionsCopy = {
    instructionsPageTitle: translate('pageTitle', 'GAME_INSTRUCTIONS-1'),
    introCopy: translate('h1', 'GAME_INSTRUCTIONS-0'),
    mainCopy1: translate('h1', 'GAME_INSTRUCTIONS-1'),
    bodyCopy1: translate('bodyCopy', 'GAME_INSTRUCTIONS-1'),
    mainCopy2: translate('h1', 'GAME_INSTRUCTIONS-2'),
    bodyCopy2: translate('bodyCopy', 'GAME_INSTRUCTIONS-2'),
    mainCopy3: translate('h1', 'GAME_INSTRUCTIONS-3'),
    bodyCopy3: translate('bodyCopy', 'GAME_INSTRUCTIONS-3'),
  }

  // console.log('tutorialContent: ', tutorialContent);
  const [ showTutorial, setShowTutorial ] = useState(false);
  const [ tutorialContentMain, setTutorialContentMain ] = useState(gameInstructionsCopy.mainCopy1);
  const [ tutorialContentAxe, setTutorialContentAxe ] = useState(gameInstructionsCopy.bodyCopy1);


  const sequencesAvailable = translate("sequencerMeta", "GAME_SEQUENCE");
  const selectedSequence = sequencesAvailable[gameLevel];
  const buttonIcons = selectedSequence.icons;
  // const buttonIcons = [
  //   {
  //     "label": "Tap",
  //     "alt": "Tapp"
  //   }];

  // const buttonIcons = translate("buttonIcons", "GAME_PLAY");
  const buttonIconsTranslated = selectedSequence.icons;
  const buttonTemplate = selectedSequence.buttonTemplate;
  // not in slice yet so temporarily using local
  // const setIsNavBarTopPositioned = useStore((state) => state.setIsNavBarTopPositioned);
  const [isNavBarTopPositioned, setIsNavBarTopPositioned] = useState(true);
  const successStarImg = globalizedMedia(translate('successStarImg', "END_GAME"), 'img');
  const { __t } = useTranslation('GAME_SEQUENCE');

  const successStarImgAlt = __t('successStarAlt', 'END_GAME');


  const [gamePadsRemoved, setGamePadsRemoved] = useState(false);
  const [buttonsIn, setButtonsIn] = useState(false);
  const [missed, setMissed] = useState(false);
  const copyWrapup = translate("END_GAME");
  const [currentH1, setCurrentH1] = useState('');
  const [padToAnnounce, setPadToAnnounce] = useState('');
  const ariaLiveMessage = useStore((state) => state.ariaLiveMessage);
  const setAriaLiveMessage = useStore((state) => state.setAriaLiveMessage);

  // volume stuff only
  const {connectSound} = useVolumeControl();

  // handle countdown
  const [showCountDown, setShowCountDown] = useState(false);
  const [countDownAnimation, setCountDownAnimation] = useState(null);

  // const bgSoundPlayer = soundEffects?.player("bgSound");
  const bgSoundTriggered = useRef(false);

  const showSettingsPanel = useStore((state) => state.showSettingsPanel);

  useEffect(() => {
    console.log("GAME LEVEL : " + gameLevel);
    console.log("GAME CHARACTER : " + gameCharacter);
  }, [gameLevel, gameCharacter])
  
/**
 * Game pad lottie config
 */
  const sequences = [
    `${buttonTemplate}_button_01.json`
    // `${buttonTemplate}_button_02.json`,
    // `${buttonTemplate}_button_03.json`
  ];
  // control play segments
  const watchSegmentStart = 35;
  const watchSegmentEnd = 55;
  const onClickSegmentStart = 70;
  const onClickSegmentEnd = 90;
  const onMissSegmentStart = 105;
  const onMissSegmentEnd = 130;

  const lottieButtons = useRef([]);
  const sequenceButtons = useRef([]);
  const buttonSFXs = useRef({});

  const [sequenceToRepeat, setSequenceToRepeat] = useState(false);


  const { vieConfigRef, updateVieConfig, goToPage } = useVieConfig();

  const {
    skipChapter,
    setSkipTarget
  } = useStore((state) => ({
    setSkipTarget: state.setSkipTarget
  }));

  useEffect(() => {
    // console.log("%c---------------------- BUTTONS INTERACTIVE ----- ", "font-size: 18px; color: green", currentCueMetadata?.id);
    console.log("---------------------------------- currentCueMetadata?.id: ", currentCueMetadata?.id, '@: ', Date.now());
  }, [currentCueMetadata?.id]);

  const pageTitle = translate('pageTitle', parentNode);
  const setPageTitle = useStore((state) => state.setPageTitle);
  const inPortrait = useStore((state) => state.inPortrait);
  useResetFocus([showSettingsPanel, inPortrait, isPauseEnabled, skipChapter]);

  useEffect(() => {
    console.log("SELECTED LEVEL : " + JSON.stringify(selectedLevel));
    console.log("GAME LEVEL: " + gameLevel + " ICONS --------------------------- : " + JSON.stringify(buttonIcons));
    console.log("=================================================== " + JSON.stringify(buttonIcons));
    return () => {
      // bgSoundPlayer?.stop();
    };
    //init section text
    setTutorialContentMain('');
  }, []); 

  useEffect(() => {
    if (currentCueMetadata?.id === "CHAPTER_INTRO") {
      setPageTitle(gameInstructionsCopy.instructionsPageTitle);
    }

    else if (currentCueMetadata?.id === "CHAPTER_COUNTDOWN") {
      setPageTitle(translate('pageTitle', parentNode));
    }

    else if (currentCueMetadata?.id === "CHAPTER_COMPLETION") {
      setPageTitle(translate('pageTitle', 'END_GAME'));
    }
  }, [currentCueMetadata?.id, showSettingsPanel, inPortrait, isPauseEnabled])


  const cueToCurrentH1 = {
    // ... __t('variantH1s'),

    "IN_ready": __t('variantH1s')["TRIGGER_READY_IN"],
    "IN_play-pattern": __t('variantH1s')["TRIGGER_PLAY-PATTERN_IN"],
    "IN_learn-pattern": __t('variantH1s')["TRIGGER_LEARN-PATTERN_IN"],
    "SUCCESS": "",
    "FAIL": ""
  };


  useEffect(() => {
    const unsub = subscribe(
      (state) => state.skipTarget,
      (skipTarget, prevSkipTarget) => {
        setIsNavBarTopPositioned(skipTarget);
      }
    );
    return () => {
      unsub();
    };
  }, [subscribe]);

  // const { goToPage } = useVieConfig({
  //   config: { ...selectedLevel.vieConfig },
  // });

  const [playDebugSfx, setPlayDebugSfx] = useState(false);
  useEffect(() => {
    if((currentCueMetadata?.id.includes("TRIGGER_TEXT") || currentCueMetadata?.id.includes("CHAPTER_TUTORIAL"))) {
      setPlayDebugSfx(false);
    } else{
      setPlayDebugSfx(true);
    }
  }, [currentCueMetadata?.id])

  // const [buttonsInteractable, setButtonsInteractable] = useState(false);
  let buttonsInteractable = false;
  const [buttonCurrentlyInteractable, setButtonCurrentlyInteractable] = useState(false);
  const setButtonsInteractable = (buttonsInteractable, position) => {
    console.log("%c---------------------- BUTTONS INTERACTIVE ----- ", "color: " + (buttonsInteractable === true ? 'lime' : 'red'), buttonsInteractable, 'position: ', position);
    document.getElementById('game-pads') && document.getElementById('game-pads').setAttribute('data-interactable', buttonsInteractable);
    if (buttonsInteractable === true && position && document.getElementById('game-pads')) {
      setButtonCurrentlyInteractable(position);
      document.getElementById('game-pads').setAttribute('data-interactable-position', position);
    } else {
      setButtonCurrentlyInteractable(false);
    }
  };
  // @2DO: const makeButtonsInteractable = (boolean) => { boolean ? ${buttonsSelector}.style.pointerEvents = mapBooToPointerEvents(boolean) }
  const [turnNumber, setTurnNumber] = useState(0);
  const [sequence, setSequence] = useState([]);
  const [userSequence, setUserSequence] = useState([]);
  const pads = buttonIcons.reduce((acc, cur) => {
    acc[cur.alt] = "";
    return acc;
  }, {});

   // loop tutorial chapters if !hit
   useEffect(() => {
     if (currentCueMetadata?.id.includes("TRIGGER_TUTORIAL-0_LOOP_OUT")) {
      // updateVieConfig({ 
      //   ...levelConfigShared,
      //   skipChapter: 'CHAPTER_TUTORIAL-0_LOOP-IN'
      // });
    //  document.querySelector('.interface-video-player').currentTime = 9.625;
    }

    else if (currentCueMetadata?.id.includes("TRIGGER_TUTORIAL-1_LOOP-OUT")) {
      // updateVieConfig({ 
      //   ...levelConfigShared,
      //   skipChapter: 'CHAPTER_TUTORIAL-1_LOOP-IN'
      // });
      // document.querySelector('.interface-video-player').currentTime = 24.2083333333333;
    }

    else if (currentCueMetadata?.id.includes("TRIGGER_TUTORIAL-2_LOOP-OUT")) {
      // updateVieConfig({ 
      //   ...levelConfigShared,
      //   skipChapter: 'CHAPTER_TUTORIAL-2_LOOP-IN'
      // });
      // document.querySelector('.interface-video-player').currentTime = 39.8333333333333;
    }

  }, [currentCueMetadata?.id]); 
  
  useEffect(() => {
    if(showSettingsPanel) {
      setIsPauseEnabled(true);
          }
  }, [showSettingsPanel])


  // stop bg sound on tab switch
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        setIsPauseEnabled(true);
        // bgSoundPlayer.stop(1);
        const soundEffectName = `gameplay-hit`;
        // soundEffectsRef?.player(soundEffectName).stop();
        // if(currentCueMetadata?.id === "CHAPTER_COUNTDOWN") {
        //   console.log("COUNTDOWN IS PLAYING...")
        //   updateVieConfig({ 
        //     ...levelConfigShared, 
        //     skipChapter: 'CHAPTER_COUNTDOWN',
        //     forceUpdate: true
        // });
        // }
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [document.visibilityState
    // , currentCueMetadata?.id
  ]);

  useEffect(() => {
    if(currentCueMetadata?.id.includes("CHAPTER_COUNTDOWN") && isPauseEnabled) {
      // document.querySelector('.interface-video-player').currentTime = 52.5;
      // console.log(document.querySelector('.interface-video-player').currentTime);
    }
  }, [currentCueMetadata?.id, isPauseEnabled])

  const handleLoadCSS = function(gameLevel) {
    if (matchSequence.gameTemplate.useRenderedSpriteCSSFiles === true) {
      // @2DO: Paths to sprites should be configurable
      // const path = (gameLevel === 1) ? `${process.env.PUBLIC_URL}/static/css/sprites/level-0_` : `${process.env.PUBLIC_URL}/static/css/sprites/level-${gameLevel}_`;
      const path = `${process.env.PUBLIC_URL}/static/css/sprites/level-${gameLevel}_`;
      // const path = `${process.env.PUBLIC_URL}/static/css/sprites/level-0_`;
  
      document.querySelectorAll('.match-sequence-sprite')?.forEach((oldSheet) => {
        oldSheet.remove();
      });
  
      // if (matchSequence.gameTemplate.levelsUseCssSprites.includes(gameLevel)) {
        matchSequence.gameTemplate.spritesToLoad.forEach((sheet) => {
          // if (sheet.includes('toy') && matchSequence.gameTemplate.levelsDontUseCssToySprites.includes(gameLevel)) {
          //   return;
          // }
          const newPath = path + sheet + '.css';
          console.log(newPath);
          const sheetElem = document.createElement('link');
          sheetElem.classList.add('match-sequence-sprite');
          sheetElem.setAttribute('type','text/css');
          sheetElem.setAttribute('rel','stylesheet');
          sheetElem.setAttribute('as','style');
          sheetElem.setAttribute('href', newPath);
          document.querySelector('body').append(sheetElem);
        });
      // }
    }
    
  }

  const handleRenderSprites = function(props) {
    // const spriteKeys = (gameLevel === 0 || gameLevel === 1 || gameLevel === 2) ? ['hit-2','toy-hit','toy-streak'] : matchSequence.gameTemplate.spritesToLoad;
    const spriteKeys = matchSequence.gameTemplate.spritesToLoad;

    if (matchSequence.gameTemplate.prefetchSpritePng === false && matchSequence.gameTemplate.renderSpritesAsBase64 === false && matchSequence.gameTemplate.useRenderedSpriteCSSFiles === false) {
      console.log('NOT FETCHING SPRITES AS BASE64 ENCODED STRINGS');
      spriteKeys.forEach((spriteKey) => {
        generateKeyframes('', spriteKey);
      });

      spriteKeys.forEach((spriteKey) => {

        let frameCount = 0;
        if (spriteKey.split('-')[0] === 'hit') {
          frameCount = gameLevelToFrameCount[gameLevel] || 60;
        } else if (spriteKey.split('-')[1] === 'streak') {
          // Assume toy-streak
          frameCount = toyAreaStreakFrameCount[gameLevel] || 60;
        } else {
          // Assume toy-hit
          frameCount = toyAreaHitFrameCount[gameLevel] || 60;
        }
        if (!spriteKey.includes('hit-')) {
          const spriteTestElem = document.createElement('div');
          spriteTestElem.innerHTML = '<div class="css-animation-element" style="animation-duration: ' + (frameCount) * 83 + 'ms"></div>';
          spriteTestElem.classList.add('sprite-preloader','css-animation-container', spriteKey);
          document.querySelector('body').append(spriteTestElem);  
        }
        if(matchSequence.gameTemplate.preloadSpritesAsImgTag === true) {
          // const path = (gameLevel === 1) ? `${process.env.PUBLIC_URL}/static/media/global/anim/sprites/gameLevel0/${spriteKey}/` : `${process.env.PUBLIC_URL}/static/media/global/anim/sprites/gameLevel${gameLevel}/${spriteKey}/`;
          const path = `${process.env.PUBLIC_URL}/static/media/global/anim/sprites/gameLevel${gameLevel}/${spriteKey}/`;
          Array.from(Array(frameCount).keys()).forEach((index) => {
            const spriteImgElem = document.createElement('img');
            let tileName = 'tile';
            if (index.toString().length < 2) {
              tileName += '00' + index;
            } else if (index.toString().length < 3) {
              tileName += '0' + index;
            }
            const tilePath = path + tileName + '.png';
            console.log('handleRenderSprites: preloadSpritesAsImgTag: tilePath: ',  tilePath);
          });

        }
      });

      if (matchSequence.gameTemplate.useGifImg.length > 0) {
        matchSequence.gameTemplate.useGifImg.forEach((kind) => {
          // @2DO: Preload gifs 
        }); 
      }

      return;
    }
  };

  /**
   * Routing based on VIE CUE
   */
  useEffect(() => {
    // console.log('currentCueMetadata: ', currentCueMetadata);
    // console.log("currentCueMetadata?.id: ", currentCueMetadata?.id);
    // setCurrentH1(currentCueMetadata?.id);

    /* TLM ONLY
    if (currentCueMetadata?.id.includes('IN_ready') || currentCueMetadata?.id.includes('IN_play-pattern') || currentCueMetadata?.id.includes('IN_learn-pattern')  || currentCueMetadata?.id.includes('fail') || currentCueMetadata?.id.includes('success')) {
      if (currentCueMetadata?.id.includes('IN_ready')) {
        setCurrentH1(cueToCurrentH1['IN_ready']);
        setAriaLiveMessage(cueToCurrentH1['IN_ready']);
        // return;
      }
      if (currentCueMetadata?.id.includes('IN_play-pattern')) {
        // setSequence([...sequence]);
        console.log(currentCueMetadata?.id.split('_'));

        let randomPad = Object.keys(pads)[Math.floor(Math.random() * Object.keys(pads).length)];
        (cheat.current) && (randomPad = Object.keys(pads)[0]);
        console.log("changing sequence: using random: ", randomPad);
        // setSequence((sequence) => [...sequence, randomPad]);
        setSequence([randomPad]);

        setCurrentH1(cueToCurrentH1['IN_play-pattern']);
        setAriaLiveMessage(cueToCurrentH1['IN_play-pattern']);
        // return;
      }
      if (currentCueMetadata?.id.includes('IN_learn-pattern')) {
        setCurrentH1(cueToCurrentH1['IN_learn-pattern']);
        setAriaLiveMessage(cueToCurrentH1['IN_learn-pattern']);
        // return;
      }
      (currentCueMetadata?.id.includes('fail')) && setCurrentH1(' ');
      (currentCueMetadata?.id.includes('success')) && setCurrentH1(' ');
    }
    
    if (currentCueMetadata?.id.includes("OUT_ready")) {
      // @2DO: This is not wise & will introduce edge case issues with pausing 
      setTimeout(() => {
        setSequenceToRepeat([ ...sequence]);
      }, 1500);
      setButtonsInteractable(false);
      return;
    }

    if (cueToCurrentH1[currentCueMetadata?.id]) {
      setCurrentH1(cueToCurrentH1[currentCueMetadata?.id]);
      setAriaLiveMessage(cueToCurrentH1[currentCueMetadata?.id]);
    } */


    // @2DO: d100 ONLY 
    const tutorial = document.querySelector('.tutorial');
      const tutorialaxe = document.querySelector(".tutorial-axe")
    if (currentCueMetadata?.id.includes("COLLAGE")) {
      // handleRenderSprites();
      return;
    } else if (currentCueMetadata?.id.includes("COMPLETION") && currentCueMetadata?.id.includes("LOOP-OUT")) {
      // updateVieConfig({
      //   skipChapter: currentCueMetadata.id.replace('-OUT','')
      // });
      return;
    } else if (currentCueMetadata?.id.includes("CHAPTER_TUTORIAL_END") ) {
      // updateVieConfig({ 
      //   ...levelConfigShared, 
      //   skipChapter: 'CHAPTER_GAMEPLAY',
      //   forceUpdate: true
      // });
      return;
    } 

    else if (currentCueMetadata?.id.includes("TRIGGER_TEXT-COUNTDOWN_IN")) {
      document.getElementById('game-pads').setAttribute('data-visible','false');
    }

    else if (currentCueMetadata?.id.includes("TRIGGER_COUNTDOWN_OUT")) {
      document.getElementById('game-pads').setAttribute('data-visible','true');
    }
    else if (currentCueMetadata?.id.includes("TRIGGER_TEXT-INTRO_IN")) {
      
      // hide pads during tutorial intro
      document.getElementById('game-pads').setAttribute('data-visible','false');
      setTutorialContentMain(gameInstructionsCopy.introCopy);
      tutorial.classList.add('tutorial-intro-text');
      tutorial.setAttribute('data-showtutorial', 'true');
      setButtonsInteractable(false);
    }

    else if (currentCueMetadata?.id.includes("TRIGGER_TEXT-INTRO_OUT")) {
      tutorial.setAttribute('data-showtutorial', 'false');
    }
    else if (currentCueMetadata?.id.includes("TRIGGER_TEXT-0_IN") ) {
      document.getElementById('game-pads').setAttribute('data-visible','true');
      tutorial.classList.remove('tutorial-intro-text');
      setTutorialContentMain(gameInstructionsCopy.mainCopy1);
      setTutorialContentAxe(gameInstructionsCopy.bodyCopy1);
      if (tutorial) {
        tutorial.setAttribute('data-showtutorial', 'true');
        tutorialaxe.setAttribute('data-showtutorialaxe', 'true')
      }
      document.getElementById('game-pads').setAttribute('data-visible','true');
    } 

    // else if (currentCueMetadata?.id.includes("TRIGGER_TEXT-0_OUT")) {
    //   if (tutorial) {
    //     tutorial.setAttribute('data-showtutorial', 'false');
    //     tutorialaxe.setAttribute('data-showtutorialaxe', 'false')
    //   }
    // }

    else if (currentCueMetadata?.id.includes("CHAPTER_TUTORIAL-1_LOOP-IN")) {
      setTutorialContentMain(gameInstructionsCopy.mainCopy2);
      setTutorialContentAxe(gameInstructionsCopy.bodyCopy2);
      // if (tutorial) {
      //   tutorial.setAttribute('data-showtutorial', 'true');
      //   tutorialaxe.setAttribute('data-showtutorialaxe', 'true')
      // }
    }

    // else if (currentCueMetadata?.id.includes("TRIGGER_TEXT-1_OUT")) {
    //   if (tutorial) {
    //     tutorial.setAttribute('data-showtutorial', 'false');
    //     tutorialaxe.setAttribute('data-showtutorialaxe', 'false')
    //   }
    // }

    else if (currentCueMetadata?.id.includes("CHAPTER_TUTORIAL-2_LOOP-IN")) {
      setTutorialContentMain(gameInstructionsCopy.mainCopy3);
      setTutorialContentAxe(gameInstructionsCopy.bodyCopy3);
      // if (tutorial) {
      //   tutorial.setAttribute('data-showtutorial', 'true');
      //   tutorialaxe.setAttribute('data-showtutorialaxe', 'true')
      // }
    }

    else if (currentCueMetadata?.id.includes("TRIGGER_TEXT-2_OUT")) {
      if (tutorial) {
        tutorial.setAttribute('data-showtutorial', 'false');
        tutorialaxe.setAttribute('data-showtutorialaxe', 'false')
      }
    }
    // else if (currentCueMetadata?.id.includes("COUNTDOWN") ) {
    //   // setShowTutorial(false);
    //   const tutorial = document.querySelector('.tutorial');
    //   const tutorialaxe = document.querySelector(".tutorial-axe")
    
    //   if (tutorial) {
    //     tutorial.setAttribute('data-showtutorial', 'false');
    //     tutorialaxe.setAttribute('data-showtutorialaxe', 'false')
    //     }
    //   }

    // if (currentCueMetadata?.id.includes("TRIGGER_TEXT_")) {
    //   if (currentCueMetadata.id.includes('OUT')) {
    //     setTutorialContentMain('');
    //   } else if (currentCueMetadata.id.includes('IN')) {
    //     setTutorialContentMain(tutorialContent.main[currentCueMetadata.id.split('TRIGGER_TEXT_')[1].split('_')[0]]);
    //   }
    // } else if (currentCueMetadata?.id.includes("TRIGGER_TEXT-HIDDEN_")) {
    //   if (currentCueMetadata.id.includes('OUT')) {
    //     // setTutorialContentAxe('');
    //     const tutorialaxe = document.querySelector('.tutorial-axe');
    //     tutorialaxe.setAttribute('data-showtutorialaxe', 'false');
    //   } else if (currentCueMetadata.id.includes('IN')) {
    //   }
      
    //   // setTutorialContentAxe(tutorialContent.axe[currentCueMetadata.id.split('TRIGGER_TEXT-HIDDEN_')[1].split('_')[0]]);
    // }

    if (currentCueMetadata?.id.includes("IN_level_animate") || currentCueMetadata?.id.includes("TRIGGER_TEXT")) {
      // @D100: Bombing out during text events prevents buttonsInteractable change
      return;
    } else if ((matchSequence.gameTemplate.renderSpriteCSSFilesEarly === true) && currentCueMetadata?.id.includes("TRIGGER_GAME-INIT")) {
      // debugger;
      initGame(matchSequence.gameTemplate);
      return;
      
    } else if (currentCueMetadata?.id.includes("IN_gameplay_buttons") || currentCueMetadata?.id.includes("CHAPTER_TUTORIAL-0_LOOP") || currentCueMetadata?.id.includes("CHAPTER_COUNTDOWN")  ) {
      !matchSequence.gameTemplate.renderSpriteCSSFilesEarly && initGame(matchSequence.gameTemplate);
      
      // handleLoadCSS(gameLevel);

      // TODO: @2DO: This needs to loop
      // if(bgSoundPlayer) {
      //   bgSoundPlayer.loop = true;
      //   bgSoundTriggered.current = true;
      //   bgSoundPlayer?.stop().start(0);
      // }
      // setButtonsIn(true);
      // (matchSequence.gameTemplate.model === 'd100') && setButtonsInteractable(true);
      return;
    } else if (currentCueMetadata?.id.includes("_HIT_")) {
      setTurnNumber(turnNumber + 1);
      const cue = currentCueMetadata?.id
      const position = cue.split('-')[0].split('HIT_')[1];
      const index = cue.split('-')[1];
      // if (history.legnth > 1) {
      //   console.timeEnd(history[history.length - 1].id);
      // }
      setSequence([parseInt(position)]);
      setPosition(position);
      
      setButtonsInteractable(true,position);

      // playsfx
      if(matchSequence.gameTemplate.debugMode && playDebugSfx && buttonsInteractable) {
        soundEffectsRef?.player('debug').stop().start(0);
      } else {
        soundEffectsRef?.player(`pad-activate-${position}`).stop(0).start(0);
      }

      // console.time(cue);
      const turn = {
        turn: turnNumber,
        cue: cue,
        id: index,
        position: position,
        state: null // false = incorrect input, true = correct input 
      };
      history.push(turn);
      console.log('history: ', history);
      
      // makeHitArea(turn);
      // makeToyArea(turn);

      if (cheat.current && !currentCueMetadata?.id.includes('TUTORIAL')) {
        setTimeout(() => {
          handlePadClick(parseInt(position),parseInt(position));
        }, 500);
      }

    } else if (currentCueMetadata?.id === "CHAPTER_TUTORIAL-1_LOOP_END") {
      // updateVieConfig({ 
      //   ...levelConfigShared,
      //   skipChapter: 'CHAPTER_TUTORIAL-0_LOOP'
      // });  
      // document.querySelector('.interface-video-player').currentTime = 4;

      const tutorialaxe = document.querySelector(".tutorial-axe")
      if (tutorialaxe) {
        tutorialaxe.setAttribute('data-showtutorialaxe', 'false')
      }
      // setTutorialContentMain(tutorialContent.main[0]);
    }

   

    else if (currentCueMetadata?.id.includes("CHAPTER_TUTORIAL-0") || currentCueMetadata?.id.includes("CHAPTER_TUTORIAL-1") || currentCueMetadata?.id.includes("CHAPTER_TUTORIAL-2")) {
      setButtonsInteractable(false)
    }

    else if (currentCueMetadata?.id.includes("TRIGGER_TUTORIAL_HIT_")) {
      // setButtonsInteractable(true,position)
    }
    else if (currentCueMetadata?.id.includes("IN_countdown")) {
      setButtonsInteractable(false);
      // @2DO: matchSequence.gameTemplate.countdownUsesLottie && 
      setShowCountDown(true);
      return;
    } else if (currentCueMetadata?.id.includes("IN_play-pattern")) {
      setButtonsInteractable(true,position);
      return;
    } else if (currentCueMetadata?.id.includes("_success")) {
      setButtonsInteractable(false);
      return;
    } else if (currentCueMetadata?.id.includes("_fail")) {
      setButtonsInteractable(false);
      return;
    } else if (currentCueMetadata?.id.includes("_transition_in_location")) {
      setCurrentLevelIndex(currentCueMetadata?.id.split('_')[1]);
      return;
    } else if (currentCueMetadata?.id.includes("_GAMEPLAY_OVER") || currentCueMetadata?.id.includes("_GAME_OVER") || currentCueMetadata?.id.includes("TRIGGER_GAMEPLAY_ALL-OUT")) {

      handleMiss(turnNumber);
      return;
 
    } else if (currentCueMetadata?.id.includes("TRIGGER") && currentCueMetadata?.id.includes("EGG")) {

      // setPageTitle(translate('pageTitle', 'END_GAME'))
      // console.log('COMPLETETION: history: ', history);
      exitGame(matchSequence.gameTemplate);
      setEndScreenWrapupVisible(true);
      // document.querySelectorAll('.cuedContent[data-id="postGameWrapUp"]').length && document.querySelectorAll('.cuedContent[data-id="postGameWrapUp"]')[0].setAttribute('data-visible','true');

      const introAnimationArea = document.createElement("div");
      introAnimationArea.classList.add('es-introAnimation','css-animation-container', `${endScreenIntro}`);
      document.querySelector(".intro-anim-container").append(introAnimationArea);
      return;

    } else if (currentCueMetadata?.id.includes("TRIGGER") && currentCueMetadata?.id.includes("ALL_IN")) {
        const outroAnimationArea = document.createElement("div");
        outroAnimationArea.classList.add('es-outroAnimation', `${endScreenOutro}`);
        outroAnimationArea.style.backgroundImage = `url(${endScreenOutroSprite})`
        let ariaLabel = endScreenAnimationAriaLabel.replace('{{intro}}', endScreenIntroLabel).replace('{{outro}}', endScreenOutroLabel);
        outroAnimationArea.setAttribute("aria-label", ariaLabel);    
        outroAnimationArea.setAttribute("role", "img");
        const outroAnimationContainer = document.querySelector(".outro-anim-container");
        outroAnimationContainer.append(outroAnimationArea);
        outroAnimationContainer.classList.add('playing');
      }

    // remove end screen content
    else if (currentCueMetadata?.id.includes("CHAPTER_COMPLETION") && currentCueMetadata?.id.includes("OUT")) {
      setEndScreenWrapupVisible(false);
      // document.querySelectorAll('.cuedContent[data-id="postGameWrapUp"]').length && document.querySelectorAll('.cuedContent[data-id="postGameWrapUp"]')[0].setAttribute('data-visible','false');
    }

    // loop end screen
    // else if (currentCueMetadata?.id === "CHAPTER_COMPLETION_LOOP") {
    //   document.querySelector('.interface-video-player').currentTime = 164;
    //   console.log("LOOPING...");
    // }
    
    else {
      (matchSequence.gameTemplate.model === 'wbdc') && setButtonsInteractable(false);
    }
  }, [currentCueMetadata?.id]); // , setSkipTarget]); 


  // hide tutorial texts if the DOM losses focus / there is no active element
  useEffect(() => {
    if (activeElem) {  
      if (currentCueMetadata?.id.includes("TUTORIAL") ) {
        const tutorial = document.querySelector('.tutorial');
        if (tutorial) {
          tutorial.setAttribute('data-showtutorial', 'true');
        }
        document.getElementById('game-pads').setAttribute('data-visible','true');
      } else if (currentCueMetadata?.id.includes("GAMEPLAY") ) {
        const tutorial = document.querySelector('.tutorial');
        const tutorialaxe = document.querySelector(".tutorial-axe")
      
        /*if (tutorial) {
          tutorial.setAttribute('data-showtutorial', 'false');
          tutorialaxe.setAttribute('data-showtutorialaxe', 'false')
          tutorial.remove();
          tutorialaxe.remove();
          }*/
      }
  
      if (currentCueMetadata?.id.includes("TRIGGER_TEXT_")) {
        if (currentCueMetadata.id.includes('OUT')) {
          setTutorialContentMain('');
        } else if (currentCueMetadata.id.includes('IN')) {
          const tutorialaxe = document.querySelector('.tutorial-axe');
      
    if (tutorialaxe) {
          tutorialaxe.setAttribute('data-showtutorialaxe', 'true');
    }
          setTutorialContentMain(tutorialContent.main[currentCueMetadata.id.split('TRIGGER_TEXT_')[1].split('_')[0]]);
          setAriaLiveMessage(tutorialContentMain);
        }
      } else if (currentCueMetadata?.id.includes("TRIGGER_TEXT-HIDDEN_")) {
        if (currentCueMetadata.id.includes('OUT')) {
          const tutorialaxe = document.querySelector('.tutorial-axe');
          tutorialaxe.setAttribute('data-showtutorialaxe', 'false');
        } else if (currentCueMetadata.id.includes('IN')) {
        }
        
        const tutorialaxe = document.querySelector('.tutorial-axe');
      
        if (tutorialaxe) {
          tutorialaxe.setAttribute('data-showtutorialaxe', 'true');
        }
      }
    } else {
      const tutorial = document.querySelector('.tutorial');
      const tutorialaxe = document.querySelector('.tutorial-axe');
      tutorial?.setAttribute('data-showtutorial', 'false');
      tutorialaxe?.setAttribute('data-showtutorialaxe', 'false');
    }
  }, [currentCueMetadata?.id, activeElem]);

  function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  
  function getRandomHitTransform(position) {
    let rotateValue;
    if (position === '0') {
      rotateValue = getRandomInt(13, 15); 
    } else if (position === '2') {
      rotateValue = getRandomInt(-13, -15);
    } else {
      rotateValue = 0;
    }
    return `rotate(${rotateValue}deg)`;
  }
  
  function getRandomDuration() {
    return `${getRandomInt(1200, 2000)}ms`;
  }
  
  const makeHitArea = function(params) {
    const hitArea = document.createElement('div');
    hitArea.setAttribute('data-cue', (params.cue));
    hitArea.setAttribute('data-position', (params.position));
    hitArea.id = 'hitArea-' + params.id;
    hitArea.style.bottom = `${matchSequence.gameTemplate.spriteVerticalOffsetMinimum}rem`;
    hitArea.classList.add('hitArea','css-animation-container');
    hitArea.style.transform = getRandomHitTransform(params.position) + ' ' + `translateY(-20rem)`;

    hitArea.style.filter = `hue-rotate(${getArbitraryInt(-15,15)}deg) saturate(${getArbitrary(1,1.15)})`; 
    const sprite = document.createElement('div');
    sprite.classList.add('css-animation-element', `hit-${(params.position)}`);

    sprite.setAttribute('data-speed', getArbitraryInt(1,3));
    // @2DO: Reconcile the above with below, remove hardcoded class based speeds
    // sprite.animation="hit-{{#}} {{1500ms}} linear infinite, ";
    
    matchSequence.gameTemplate.loopSprites && (sprite.style.animationIterationCount = 'infinite');
    hitArea.appendChild(sprite);
    // document.querySelector('.game-play').append(hitArea);
    matchSequence.spriteElem.append(hitArea);
    console.log('making: ', hitArea);
    if (matchSequence.gameTemplate.removeSpritesOnAnimationEnd && matchSequence.gameTemplate.debugHits === false) { 
      sprite.addEventListener('animationend', () => {
                  hitArea.remove();
              });
      setTimeout(() => {
         hitArea && hitArea.remove();
      }, matchSequence.gameTemplate.garbageTimeout);

    } else if (matchSequence.gameTemplate.garbageTimeout && matchSequence.gameTemplate.debugHits === false) {
    }
    
  }

  // const getRandomHitTransform = function() {
  //   return `rotate(${getArbitraryInt(-15,15)}deg) 
  //   scale(${Math.random() * 1 > 0.5 ? '1' : '-1'}) translateY(-50%) translateX(-50%)`;  
  // }

  // const getRandomHitTransform = function() {
  //   return `translateY(-20rem) `;  
  // }

  const getToyAnimationDurationInMS = function(kind) {
    return kind === 'hit' ? parseInt(toyAreaHitFrameCount[gameLevel] / 2) * 83 : parseInt(toyAreaStreakFrameCount[gameLevel] / 2) * 83;
  };

  const makeToyArea = function(params) {
    const toyArea = document.createElement('div');
    toyArea.setAttribute('data-position', 2); // params.position);
    toyArea.id = 'toyArea-' + params.id;
    toyArea.classList.add('toyArea','css-animation-container');

    const sprite = document.createElement('div');

    !matchSequence.gameTemplate.streaksUseToySprites && (params.kind = 'hit');
    sprite.classList.add('css-animation-element', 'toy-' + params.kind);
    sprite.style.animationDuration = getToyAnimationDurationInMS(params.kind) + 'ms';
    matchSequence.gameTemplate.loopSprites ? (sprite.style.animationIterationCount = 'infinite') : (sprite.style.animationIterationCount = '1');
    setTimeout(() => {
      toyArea.appendChild(sprite);
      soundEffectsRef?.player(`toy-hit`).stop(0).start(0);
    }, 1000)    
    matchSequence.spriteToyElem.append(toyArea);
    console.log('making: toyArea: ', toyArea);

    if (matchSequence.gameTemplate.removeSpritesOnAnimationEnd && matchSequence.gameTemplate.debugToyHits === false) { 
      sprite.addEventListener('animationend', () => {
        toyArea.remove();
      });
      setTimeout(() => {
         toyArea && toyArea.remove();
      }, matchSequence.gameTemplate.garbageTimeout);
    }

  }

  const makeStaticToyAreaContainer = function(params) {
    console.log(document.getElementById('toyArea'));
    const toyArea = document.getElementById('toyArea');
    toyArea.setAttribute('data-position', 2);
    toyArea.id = 'toyArea';
    toyArea.classList.add('toyArea','css-animation-container');
    matchSequence.spriteElem.append(toyArea);
    console.log('making: static: toyAreaContainer: ', toyArea);
  }

  const makeStaticToyArea = function(params) {
    const toyArea = document.getElementById('toyArea');
    const sprite = document.createElement('div');
    sprite.id = 'toyArea-' + params.id;
    sprite.classList.add('css-animation-element', 'toyArea', 'toy-' + params.kind);
    toyArea.appendChild(sprite);

    if (matchSequence.gameTemplate.debugHits === false) { 
      setTimeout(() => {
        sprite && sprite.remove();
      }, getToyAnimationDurationInMS(params.kind) + matchSequence.gameTemplate.garbageTimeout);
    }
  }

  const makeStaticToyAreaGif = function(params) {
    const toyArea = document.getElementById('toyArea');
    const sprite = document.createElement('div');
    sprite.id = 'toyArea-' + params.id;
    sprite.classList.add('css-animation-element', 'toyArea'); // , 'toy-' + params.kind);
    
    // const path = (gameLevel === 1) ? `${process.env.PUBLIC_URL}/static/media/global/anim/sprites/gameLevel0/` : `${process.env.PUBLIC_URL}/static/media/global/anim/sprites/gameLevel${gameLevel}/`;
    const path = `${process.env.PUBLIC_URL}/static/media/global/anim/sprites/gameLevel${gameLevel}/`;
    sprite.style.backgroundImage = `url(${path}toy-${params.kind}.gif)`; 
    toyArea.appendChild(sprite);
    
    (matchSequence.gameTemplate.debugHits === false) && setTimeout(() => {
      sprite.remove();
    }, getToyAnimationDurationInMS(params.kind) + matchSequence.gameTemplate.garbageTimeout);
  }

  const makeStaticToyAreaGifImg = function(params) {
    // const toyArea = document.getElementById('toyArea');
    const toyArea = matchSequence.spriteToyElem;
    // const sprite = new Image();
    const path = (gameLevel === 1) ? `${process.env.PUBLIC_URL}/static/media/global/anim/sprites/gameLevel0/` : `${process.env.PUBLIC_URL}/static/media/global/anim/sprites/gameLevel${gameLevel}/`;
    // const filePath = `${path}toy-${params.kind}${params.kind === 'hitme' ? ('-' + getArbitraryInt(0,2)) : ''}.gif`; 
    const filePath = `${path}toy-${params.kind}.gif`;
    const sprite = `<img id="toyArea-${params.id}" src="${filePath}" class="css-animation-element sprite-gif toyArea toy-${params.kind}" />`;
    toyArea.innerHTML += sprite;
    
    if (matchSequence.gameTemplate.removeSpritesOnAnimationEnd && matchSequence.gameTemplate.debugHits === false) { 
      setTimeout(() => {
        document.getElementById(`toyArea-${params.id}`).remove();
      }, getToyAnimationDurationInMS(params.kind) + matchSequence.gameTemplate.garbageTimeout);
    }
  }

  /**
   *
   * Repeat the current sequence array to user
   *    by using [0] then removing it from seqeunceToRepeat array
   *
   */

  useEffect(() => {
    console.log('CHANGED: sequenceToRepeat: ', sequenceToRepeat);
    if (sequenceToRepeat.length > 0 && !isPauseEnabled) {
      // Repeat the sequence element to the user 
      console.log('REPEATING: sequenceToRepeat[0]: ', sequenceToRepeat[0]);
      const index = 0;
      const slug = sequenceToRepeat[index];
      playSfx(buttonIcons.findIndex(obj => obj.alt === slug));
      playButtonAnimation(slug, watchSegmentStart, watchSegmentEnd);
      // setAriaLiveMessage(slug);
      // setAriaLiveMessage(slug + ' ');
      if (sequenceToRepeat.length > 1) {
        setTimeout(() => {
          // setAriaLiveMessage(' ');
        }, 500);
      }
      // Remove the element from the array after a delay, retrigger repeating -> sequenceToRepeat
      setTimeout(() => {
        // setAriaLiveMessage(' ');
        setSequenceToRepeat([...sequenceToRepeat.slice(1)]);
      }, 1000);
    } else if (sequenceToRepeat.length === 0 && !isPauseEnabled) {
      console.log('ENDED: sequenceToRepeat: sequenceToRepeat.length: ', sequenceToRepeat.length);
      console.log('currentLevelIndex: ', currentLevelIndex);
      console.log('levels: ', levels);
      const currentLevel = levels[currentLevelIndex];
      console.log('currentLevel: ', currentLevel);
      updateVieConfig({ ...levelConfigShared, skipChapter: 'LEVEL_' + currentLevelIndex + "_TRIGGER_IN_play-pattern"});
    }
  }, [sequenceToRepeat]);

  /**
   *
   * Return user to beginning of LEARN sequence on unpause –
   *    so that they can see the sequence from the beginning
   *
   */

  useEffect(() => {
    if (sequence.length >= 1 && !isPauseEnabled && (currentCueMetadata?.id.includes('learn-pattern') || currentCueMetadata?.id.includes('present_idle'))) {
      console.log('SKIPPING BACK TO LEARN');
      updateVieConfig({ 
        ...levelConfigShared, 
        skipChapter: 'LEVEL_' + currentLevelIndex + '_TRIGGER_IN_learn-pattern',
        forceUpdate: true
      });
      setSequenceToRepeat(sequence);
    }
  }, [isPauseEnabled]);


  /**
   *
   * Pause -> know how long ago since user paused
   *
   */

  // restart gameplay when pause > 30sec
  const [lastPauseTime, setLastPauseTime] = useState(null);
  useEffect(() => {
    if(matchSequence.gameTemplate.usePauseTimeoutToRestartGame) {
      if(!currentCueMetadata?.id.includes('COMPLETION')) {
        if (isPauseEnabled) {
          setLastPauseTime(new Date().getTime());
        } else if (lastPauseTime !== null) {
          const currentUTC = new Date().getTime();
          const timePaused = currentUTC - lastPauseTime;
    
          if (timePaused > 10000) {
            // goToPage('REPLAY');
          }
        }
      }
    }
  }, [isPauseEnabled]);

  const sequenceEquivalence = function (a, b) {
    return (
      Array.isArray(a) &&
      Array.isArray(b) &&
      a.length === b.length &&
      a.every((val, index) => val === b[index])
    );
  }

  const incrementSequence = (turnNumber) => {
    // @2DO: This should become increment turn then let incrementSequence be exclusively a sequence increment 
    console.log('INCREMENTING SEQUENCE: TURN NUMBER: ', turnNumber);
    console.log('INCREMENTING SEQUENCE: sequence.length: ', turnNumber);

    // @2DO: These conditionals will get complicated quickly 
    // if (matchSequence.gameTemplate.completeSequenceAt === sequence.length) {
    //   console.log('increment sequence: sequence.length === completeSequenceAt -> returning [...sequence]');
    //   setSequence([...sequence]);
    //   return sequence;
    // }

    if (matchSequence.gameTemplate.model === "wbdc") {
      let randomPad = Object.keys(pads)[Math.floor(Math.random() * Object.keys(pads).length)];
      (cheat.current) && (randomPad = Object.keys(pads)[0]);
      
      // console.log('increment sequence: sequence.length === completeSequenceAt -> returning [...sequence]');
      // @2DO: Should not do this here – the incoming VIE cue will change the sequence. 
        // Using cue.id = play-pattern for now
      // setSequence([...sequence]);
      if (sequence.length < matchSequence.gameTemplate.initialSequenceLength ) {
        // if (turnNumber === sequence.length || sequence.length < matchSequence.gameTemplate.initialSequenceLength) {
          console.log("incrementingSequence: ", randomPad);
          // setSequence((sequence) => [...sequence, randomPad]);
          if (history.length > 0) {
            setSequence([history[turnNumber].position]);
          } else {
            setSequence((sequence) => [...sequence, randomPad]);
          }
          return sequence;
        // }    
      }
      //   console.log('increment sequence: sequence.length === completeSequenceAt -> returning [...sequence]');
      //   setSequence([...sequence]);
      //   return sequence;
      // }
      return sequence;

    }

    if (turnNumber === sequence.length) {
      let randomPad = Object.keys(pads)[Math.floor(Math.random() * Object.keys(pads).length)];
      (cheat.current) && (randomPad = Object.keys(pads)[0]);
      console.log("incrementingSequence: ", randomPad);
      setSequence((sequence) => [...sequence, randomPad]);
      return sequence;
    }
  };

  const checkUserSequence = (turnNumber) => {
    if (userSequence.length > 0) {
      console.log('CHECK SEQUENCE EQUIVALENCE:');
      console.log('userSequence: ', userSequence);
      console.log('sequence: ', sequence);

      if (sequenceEquivalence(sequence.slice(0, userSequence.length), userSequence)) {
        console.log('userSequence: at least partially equivalent');
        if (sequenceEquivalence(userSequence, sequence)) {
          setButtonsInteractable(false);
          handleHit(turnNumber);
          return;
        }
        return;
      } else {
        // handleMiss(turnNumber);
        return;
      }
    }
  };

  const playSfx = (sfxId) => {
    const soundEffectName = `gameplay-hit`;
    soundEffectsRef?.player(soundEffectName).stop().start(0);
    console.log("%c---------------------- WATCH SOUND PLAYED ----- ", "color: yellow", soundEffectName);
  }

  // const handleTurn = (turnNumber) => {
  //   console.log('ENDING TURN: ', turnNumber);
  //   console.log('CLEARING: userSequence');
  //   // if (userSequence.length !== 0) {
  //     setUserSequence([]);
  //   // }
  //   console.log("sequence: ", sequence);
  //   console.log('userSequence: ', userSequence);
  //   let turnNext = turnNumber + 1;
  //   setTurnNumber(turnNext);
  //   incrementSequence(turnNext);
  // };

  const handleStreaks = (turnNumber) => {
    let streakValues;
    console.log(availableStreaks);
    if (matchSequence.gameTemplate.debugStreaks === true) {
      streakValues = {
        "2": '2x',
        "4": '4x',
        "6": '6x',
        "8": '8x',
        "10": '10xb',
        "25": '25x',
        "50": '50x',
        "75": '75x',
        "100": '100x'
      };
    } else {
      streakValues = availableStreaks;
    }
      
    const completionMarks = [0,3,6]; // d100: [0, 1, 2, 4, 6, 8, 9];
    const completionMarkToScore = {
      0 : 1,
      1 : 1,
      2 : 1,
      3 : 1,
      4 : 2,
      5 : 2,
      6 : 2,
      7 : 2,
      8 : 3,
      9:  3,
      10: 3
    } 

    let streak = 0;
    let streakValue = 0;
    let totalWins = 0;
    let totalPercent = 0;
    let showSprite = false;
    const historyFlat = [];
    history.forEach((item) => {
      historyFlat.push(item.state);
      if (item.state === true) {
        totalWins++;
      }
    });
    console.log('totalWins: ', totalWins, 'of: ', historyFlat.length);
    totalPercent = totalWins / historyFlat.length;
    console.log('total %: ', totalPercent);
    console.log('history:', history);
    console.log('historyFlat:', historyFlat);
    // console.log('historyFlat.lastIndexOf(null): ', historyFlat.lastIndexOf(null));
    // console.log('history[historyFlat.lastIndexOf(null)]: ', history[historyFlat.lastIndexOf(null)]);
    // console.log('historyFlat.length - historyFlat.lastIndexOf(null): ', historyFlat.length - historyFlat.lastIndexOf(null));
    const streaksToKeys = Object.keys(streakValues);
    streak = historyFlat.length - 1 - historyFlat.lastIndexOf(null);
    console.log('streak: ', streak);
    const indexOfStreakValue = streaksToKeys.indexOf(streak.toString());
    // console.log('Object.keys(streakValues).indexOf(streak)', indexOfStreakValue);

    streakValue = streakValues[streaksToKeys[indexOfStreakValue]];
    // streakValue = availableStreaks[streaksToKeys[indexOfStreakValue]];

    console.log('streakValue: ', streakValue);
    // if (historyFlat.length - historyFlat.lastIndexOf(null) > 1) {
    if (typeof streakValue != 'undefined') {
      showSprite = true;
    // } else if () {
    } else if (historyFlat.length - 1 === totalWins) { 
      console.log('Perfect score!', history.length - 1);
      // streakValue = 'Perfect!';
    }

    // console.log('history.length - 1:', history.length - 1);
    // console.log('history.length - 1 === historyFlat.lastIndexOf(null): ', history.length - 1 === historyFlat.lastIndexOf(null));
    // console.log('historyFlat.lastIndexOf(null): ', historyFlat.lastIndexOf(null));

    const completionValue = parseInt(totalPercent * 10);
    let finalScore = completionMarkToScore[completionValue];
    let completionTotal = completionMarks[finalScore - 1]; // d100 only:  completionMarks[finalScore - 1];  

    return {
      totalPercent: totalPercent,
      completionValue: completionValue,
      streakValue: streakValue,
      streak: streak,
      showSprite: showSprite,
      // indexOfStreakValue: indexOfStreakValue,
      finalScore: finalScore,
      completionTotal: completionTotal
    };
  };

  const makeStreakElem = function(streakResult) {

    if (typeof streakResult.streakValue != 'undefined') {
      const streakElem = document.createElement('div');
      streakElem.classList.add('streakElem');
      streakElem.innerText = streakResult.streakValue;
      setStreakHeader(streakResult.streakValue);

      if (matchSequence.gameTemplate.streaksUseSpriteBackgrounds) {
        // @2DO: Render streak burst sprite animation element 
        const streakAnimationContainer = document.createElement('div');
        streakAnimationContainer.classList.add('streak-anim-container');
        streakAnimationContainer.setAttribute('aria-hidden', 'true');
        const streakAnimationElement = document.createElement('div');
        streakAnimationElement.classList.add('streak-anim-element');
        streakAnimationContainer.appendChild(streakAnimationElement);
        document.querySelector('.section-game').appendChild(streakAnimationContainer);
      }

      // document.querySelector('.game-play').append(streakElem);
      soundEffectsRef?.player("starWarsStreak").stop().start(0);
      setAriaLiveMessage(streakResult.streakValue);
    
      setTimeout(() => {
        !matchSequence.gameTemplate.debugStreaks && streakElem.remove();
        setStreakHeader("");
        setAriaLiveMessage('');
        document.querySelector('.streak-anim-container') && document.querySelector('.streak-anim-container').remove();
      }, 1000);
    }
  }

  const handleHit = (turnNumber) => {
    console.log("handleHit: Hit!");
    console.log("handleHit: turnNumber: ", turnNumber);
    console.log("handleHit: sequence: ", sequence);
    console.log('handleHit: userSequence: ', userSequence);
    const newItem = history[history.length-1];
    newItem.state = true;
    newItem.cue = currentCueMetadata?.id;

    console.log('history: ', history);    
    // const turn = history[turnNumber];
    const turn = newItem;

    console.log('handleHit: history[turnNumber]: ', turn);
    // console.log('handleHit: history[turnNumber].id: ', turn.id);
    console.log('handleHit: history[turnNumber].position: ', turn.position);

    // console.log("currentCueMetadata?.id: ", currentCueMetadata?.id);
    // if (!currentCueMetadata?.id.includes('_HIT') && !currentCueMetadata?.id.includes('TUTORIAL') ) { 
    //   console.log('NOT HIT-ABLE: currentCueMetadata?.id: ', currentCueMetadata?.id);
    //   return false;
    // }

    // playSfx(index);
    soundEffectsRef?.player(`pad-handle-hit`).stop().start(0); // @2DO: Does this happen if you get it wrong 

    const shakeElem = document.querySelector('.game-wrapper');

    shakeElem.addEventListener('webkitAnimationEnd', function(){
        this.style.webkitAnimationName = '';
    }, false);

    // shakeElem.getElementById('button').onclick = function(){
    //   shakeElem.style.animationDuration = '0.25s';
    // });
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('shake') === "true") {
      shakeElem.style.animationName = 'shake';
    }
    // setTimeout((shakeElem) => {
    //   shakeElem && (shakeElem.style.animation = 'shake 0.25s');
    // }, 25);


    const streakResult = { ... handleStreaks(turnNumber), turnNumber: turnNumber }; 
    if (typeof streakResult.streakValue !== 'undefined') {
      makeStreakElem(streakResult);
    }
    console.log('handleHit: streakResult: ', streakResult);

    const streakValue = streakResult.streakValue;

    makeHitArea(turn);
    document.getElementById('hitArea-' + turn.id)?.classList.add('px', 'hit-' + turn.position);
    // const toyElem = document.getElementById('toyArea-' + turn.id);
    // document.querySelectorAll('.toyArea').forEach((toyArea) => {
    //   toyArea.remove();
    // });
    const toyElem = document.getElementById('toyArea');
    const turnProps = {
      cue: turn.id,
      id: turnNumber,
      position: 2,
      kind: (typeof streakValue != 'undefined') ? 'streak': 'hit',
    };
    // matchSequence.gameTemplate.useStaticToyArea && (!matchSequence.gameTemplate.levelsDontUseCssToySprites.includes(gameLevel) ? makeStaticToyArea(turnProps) : makeStaticToyAreaGifImg(turnProps));
    makeToyArea(turnProps);
    

    // console.log('currentCueMetadata: ', currentCueMetadata);
    // console.log('currentCueMetadata?.endTime: ', currentCueMetadata?.endTime);
    // let spriteVerticalOffset = 8 + 42 * (currentCueMetadata?.endTime - document.querySelector('.interface-video-player').currentTime);
    let spriteVerticalOffset =  3 + 32 * (currentCueMetadata?.endTime - document.querySelector('.interface-video-player').currentTime);
    spriteVerticalOffset = spriteVerticalOffset < matchSequence.gameTemplate.spriteVerticalOffsetMinimum ? matchSequence.gameTemplate.spriteVerticalOffsetMinimum : spriteVerticalOffset;
    console.log('spriteVerticalOffset: ', spriteVerticalOffset);
    // document.getElementById('hitArea-' + turn.cue.split('-')[1]) && (document.getElementById('hitArea-' + turn.cue.split('-')[1]).style.top = spriteVerticalOffset + 'rem');

    // setPosition(playthrough.history[playthrough.history.length - 1].position);
    // console.log('playthrough: ', playthrough);
    console.log('CLEARING: userSequence');
    setUserSequence([]);

    console.log('ENDING TURN: ', turnNumber);
    let turnNext = turnNumber + 1;
    setTurnNumber(turnNext);
    console.log('currentLevelIndex: ', currentLevelIndex);

    // Clicked_element -> Hit_animation
    // document.activeElement.blur();
    // let vieConfig = { ...levels[parseInt(currentLevelIndex) - 1].vieConfig };

    // FAST LEVEL SWITCHING 
    if (matchSequence.gameTemplate.fastLevelSwitch > 0) {
      if (sequence.length % 3 === 0) { 
        handleFastLevelSwitch(turnNumber); 
      } else {
        updateVieConfig({ 
          ...levelConfigShared,
          skipChapter: 'LEVEL_' + currentLevelIndex + '_CHAPTER_success'
        });
        incrementSequence(turnNext);
      }
      return;
    }
    if (matchSequence.gameTemplate.model === 'wbdc') {
      console.log('handleHit: gameTemplate: wbdc');
      if (currentCueMetadata?.id.includes('TRIGGER_TUTORIAL_HIT_0') || currentCueMetadata?.id.includes('TRIGGER_TEXT_0')) {
        updateVieConfig({ 
          ...levelConfigShared,
          skipChapter: 'TRIGGER_TEXT-0_OUT'
        });
        incrementSequence(turnNext);
      } 

      else if (currentCueMetadata?.id.includes('TRIGGER_TUTORIAL_HIT_1')) {
        updateVieConfig({ 
          ...levelConfigShared,
          skipChapter: 'TRIGGER_TEXT-1_OUT'
        });
        incrementSequence(turnNext);
      } 

      else if (currentCueMetadata?.id.includes('TRIGGER_TUTORIAL_HIT_2')) {
        updateVieConfig({ 
          ...levelConfigShared,
          skipChapter: 'TRIGGER_TEXT-2_OUT'
        });
        incrementSequence(turnNext);
      } 
      
      // else if (currentCueMetadata?.id.includes('TRIGGER_TUT_HIT')) {
      //   updateVieConfig({ 
      //     ...levelConfigShared,
      //     skipChapter: 'CHAPTER_COUNTDOWN'
      //   });
        // incrementSequence(turnNext);
      // }  
    }
  };

  useEffect(() => {
    if(currentCueMetadata?.id === "TRIGGER_TUT_HIT_2-2") {
      setTutorialContentAxe(tutorialContent.axe[1]);
    }
  }, [currentCueMetadata?.id])

  // @2DO: Make this conditional, or remove entirely
  useEffect(() => {
    console.log('CHANGING: previousLevelIndex: ', previousLevelIndex);
  }, [previousLevelIndex])

  // @2DO: Make this conditional, or remove entirely
  const handleFastLevelSwitch = useCallback((turnNumber) => {
    if (turnNumber > 0) {
      console.log('currentLevelIndex: ', currentLevelIndex);
      const randomLevelIndex = 0 + getRandomLevel();
      console.log('proposing to fast level switch to: getRandomLevel: ', randomLevelIndex);
      console.log('currentLevelIndex, randomLevelIndex: ', currentLevelIndex, randomLevelIndex);
  
      if (currentLevelIndex === randomLevelIndex) {
        console.log('proposal matches current level, looping');
        handleFastLevelSwitch(turnNumber);
      } else {
        console.log('new level found, switching');
        setCurrentLevelIndex(randomLevelIndex);
        return randomLevelIndex;
      }
    }
  }, [currentLevelIndex]);

  // @2DO: Make this conditional, or remove entirely
  const previousValues = usePrevious({
    currentLevelIndex
  });
  useEffect(() => {
    console.log('currentLevelIndex: ', currentLevelIndex, 'previousLevelIndex:', previousLevelIndex);
    // if ((turnNumber !== 0) && (turnNumber % 2 === 0) && currentLevelIndex !== previousLevelIndex ) {
    if ((turnNumber !== 0 && sequence.length % 3 === 0) && currentLevelIndex !== previousValues.currentLevelIndex ) {
      console.log('currentLevelIndex !== previousLevelIndex');
      updateVieConfig({
        ...levelConfigShared,
        skipChapter: 'LEVEL_' + previousValues.currentLevelIndex + '_CHAPTER_transition_out_location',
        out_target: 'LEVEL_' + currentLevelIndex + '_CHAPTER_transition_in_location'
       });
      incrementSequence(turnNumber);
    }
  }, [currentLevelIndex]);

  
  // show random praise word on game end screen
  const [praiseWord, setPraiseWord] = useState('');

  // useEffect(() => {
  //   const words = copyWrapup.h1.split(' | ');
  //   const randomIndex = Math.floor(Math.random() * words.length);
  //   const selectedWord = words[randomIndex];
  //   setPraiseWord(selectedWord);
  // }, [currentCueMetadata]);

  const handleMiss = () => {

    // alert('miss!');

    setButtonsInteractable(false);
    setMissed(true);
    setCurrentH1('');
    console.log("Miss!");
    console.log('currentLevelIndex: ', currentLevelIndex);

    const streakResults = handleStreaks(turnNumber);
    let completionTotal = streakResults.completionTotal;
    if (urlParams.get('completion')) {
      // @2DO: Make a fake history array such that handleStreaks() works correctly
      completionTotal = urlParams.get('completion');
    }
    let finalScore = streakResults.finalScore;

    console.log("COMPLETION TOTAL: " + completionTotal);
    console.log("FINAL SCORE: " + finalScore);
    // let vieConfig = { ...levelConfigShared, skipChapter: "CHAPTER_COMPLETION-" + completionTotal + '_IN'};
    let vieConfig = { ...levelConfigShared, skipChapter: "TRIGGER_GAMEPLAY_ALL-OUT"};
    // updateVieConfig({
      //   // skipChapter:  "TRIGGER_GAMEPLAY_ALL-OUT"
      //   skipChapter:  "TRIGGER_GAMEPLAY-EXIT"
      // });

    // matchSequence.gameTemplate.model = 'TLM' && (vieConfig.skipChapter = 'LEVEL_' + currentLevelIndex + "_CHAPTER_fail");
    // matchSequence.gameTemplate.model = 'TLM' && let score = sequence.length -1;
    // let score = completionTotal;

    const words = copyWrapup.h1.split(' | ');
    const selectedWord = words[finalScore - 1];
    console.log("WORDS :::::::: " + words)
    console.log("SELECTED WORKD :::::::: " + selectedWord)

    // setPraiseWord(selectedWord);



    vieConfig.overlays = ( <div
        data-visible={endScreenWrapupVisible}
        // data-visibleoncues="CHAPTER_COMPLETION-0" // @2DO: FIX THESE
        className="cuedContent"
        data-id="postGameWrapUp"
    >
      <div className="end-screen-container">
        <div className="end-screen-copy">
          <div className="score-h1">
            <h1 className="postGameH1-a11y" data-wrapup-h1={copyWrapup.h1} aria-hidden="true">{copyWrapup.h1}</h1>
            <h1 className="postGameH1">{copyWrapup.h1}</h1>
          </div>
        </div>

        <div className="outro-anim-container" tabIndex={1}></div>

        <div className="anim-container">
          <div className="intro-anim-container"></div>
        </div>

        <div className="score-p">
            <p className="postGameP-a11y" data-wrapup-p={endScreenOutro} aria-hidden="true">{endScreenOutroLabel}</p>
            <p className="postGameP">{endScreenOutroLabel}</p>
        </div>
        <div className="end-screen-copy-2">
        <div className="disclaimer-cta-container">
        <ul className="disclaimer-btn-list">
        <li>
          <CTAButton
              onClick={(evt) => {
                goToPage('LEVEL_SELECTION');
              }}
              intlKey={'button'}
              label={copyWrapup.menuButton.label}
              ariaLabel={copyWrapup.menuButton.label}
          />
        </li>
         {copyWrapup.menuButton && (<li>
          <CTAButton
              primary
              onClick={(evt) => {
                goToPage('REPLAY');
              }}
              intlKey={'button'}
              label={copyWrapup.playAgain.label}
              ariaLabel={copyWrapup.playAgain.label}
          />
        </li>)}
      </ul>
        </div>
        </div>
      </div>
    </div>);
    updateVieConfig(vieConfig);
    // End game
    // Clicked_element -> Miss_animation
    // Await finish of Miss_animation
    // Dump game output to playthroughs.history.array
    // Push new viewcConfig
    // alert("YOU FAILED (LAME)");
    return;
  };

  useEffect(() => {
    const streakResults = handleStreaks(turnNumber);
    let completionTotal = streakResults.completionTotal;
    let finalScore = streakResults.finalScore;

    console.log("COMPLETION TOTAL: " + completionTotal);
    console.log("FINAL SCORE: " + finalScore);
  }, [currentCueMetadata])

  // const handleWin = () => {};

  const initGame = (gameTemplate) => {
    console.log('initing game');
    
    document.querySelector('#spriteElem') && document.querySelector('#spriteElem').remove();
    document.querySelector('#spriteToyElem') && document.querySelector('#spriteToyElem').remove();

    // handleCues();
    setHistory([{
      turn: 0,
      id: 0,
      cue: 'TRIGGER_HIT_2-0',
      position: 2,
      state: null
    }]);
    
    setSequence([]);
    setUserSequence([]);
    setTurnNumber(0);
    // gameTemplate.initialSequenceLength = 3;
    if (gameTemplate.initialSequenceLength === 1) {
      incrementSequence(turnNumber);
      // return;
    // } else {
    //   for (let i = 0; i < gameTemplate.initialSequenceLength; i++) {
    //     incrementSequence(turnNumber);
    //   }
    }

    // handleRenderSprites();
    handleLoadCSS(gameLevel);


    matchSequence.spriteToyElem = document.createElement('div');
    matchSequence.spriteToyElem.id ='spriteToyElem';
    matchSequence.spriteToyElem.style.width = document.querySelector('.interface-video-player').getBoundingClientRect().width + 'px';
    document.querySelector('#VIE-Player .video-container').append(matchSequence.spriteToyElem);

    matchSequence.spriteElem = document.createElement('div');
    matchSequence.spriteElem.id = 'spriteElem';
    matchSequence.spriteElem.style.width = document.querySelector('.interface-video-player').getBoundingClientRect().width + 'px';
    document.querySelector('#VIE-Player .video-container').append(matchSequence.spriteElem);

    // makeStaticToyAreaContainer({
    //   // target: document.getElementById('toyArea'),
    //   position: 2,
    // });

    // incrementSequence({
    //   turnNumber: turnNumber,
    //   amount: gameTemplate.initialSequenceLength
    // });
    setButtonsInteractable(false);
    setButtonsIn(true);
    // (matchSequence.gameTemplate.model === 'wbdc') && setButtonsInteractable(true,2);
  };

  const exitGame = (gameTemplate) => { 
    console.log('exitGame: exiting ...');
    setGamePadsRemoved(true);

    matchSequence.gameTemplate.elemsToDestroyOnExit.forEach((selector) => {
      document.querySelector(selector) && document.querySelector(selector).remove();
    });

    // @2DO: Destroy eventListeners 
  };



  // const onComplete = (event, index) => {
  //   console.log(`SEQUENCE BUTTON ${index} COMPLETED PLAYING SEGMENT.`);
  // };


  // handle press
  const handlePadClick = (pad, index) => {
    console.log('USER INPUT: ', pad);
    console.log('handlePadClick: currentCueMetadata?.id', currentCueMetadata?.id);

    // if (buttonsInteractable === false) {
    //   console.log('buttons uninteractable');
    //   return;
    // };

    setButtonsInteractable(false);
    
    // connectSound(soundEffects.current)
    // setAriaLiveMessage(pad);
    if (currentCueMetadata?.id === "CHAPTER_TUTORIAL_LOOP") {
      // document.activeElement.blur();
    }

    matchSequence.gameTemplate.buttonsUseLotties && sequenceButtons.current[index].playSegments([onClickSegmentStart, onClickSegmentEnd], true);
    //console.log("%c---------------------- PRESS SOUND PLAYED ----- ", "font-size: 24px; color: green", soundEffectName);
    if (userSequence.length < matchSequence.gameTemplate.completeSequenceAt) {
      // setUserSequence((userSequence) => [...userSequence, pad]);
      setUserSequence((userSequence) => [...userSequence, index]);
    } else {
      // alert('sequence too long');
      return;
    }

};

  // playSegment with pads
  const playButtonAnimation = (buttonName, start, end) => {
    const buttonIndex = buttonIcons.findIndex((icon) => icon.alt === buttonName);
    if (buttonIndex >= 0 && sequenceButtons.current[buttonIndex]) {
      matchSequence.gameTemplate.buttonsUseLotties && sequenceButtons.current[buttonIndex].playSegments([start, end], true);
    }
  };

  // useEffect(() => {
  //   console.log("%c---------------------- BUTTONS INTERACTIVE ----- ", "color: red", buttonsInteractable);
  //   document.getElementById('game-pads').setAttribute('data-interactable', buttonsInteractable);
  // }, [buttonsInteractable]);

  useEffect(() => {
    console.log("TURN CHANGED: ", turnNumber);
  }, [turnNumber]);

  useEffect(() => {
    console.log("USER SEQUENCE CHANGED: ", userSequence);
    if (userSequence.length > 0) {
      if (matchSequence.gameTemplate.omniButton === true) {
        setButtonsInteractable(false);
        handleHit(turnNumber);
        return;
      }
      checkUserSequence(turnNumber);
    }
  }, [userSequence]);

  // @2DO: Remove this under config flag 

  useEffect(() => {
    console.log("SEQUENCE CHANGED: ", sequence);
    if (matchSequence.gameTemplate.buttonsUseLotties === true) {
        if (matchSequence.gameTemplate.buttonsUseLotties && currentCueMetadata?.id.includes('IN_gameplay_buttons') ){
          lottieButtons.current = document.querySelectorAll(".lottie-button");

          // lottie setup
          sequenceButtons.current = sequences.map((sequence, index) =>
            lottie.loadAnimation({
              container: lottieButtons.current[index],
              renderer: "svg",
              name: buttonIcons[index].alt,
              loop: false,
              autoplay: false,
              animationData: require(`./LottieButtons/${buttonTemplate}/${sequence}`)
            }), {}
          );
      }
    }
  }, [sequence]);


  useEffect(() => {
    console.log('missed: ', missed);

    // handle miss
    if (missed) {
      console.log('missed: userSequence.last: ', userSequence[userSequence.length - 1]);
      console.log('buttonIcons: ', buttonIcons);
      // @2DO: Fix this with parent selector .cueContent[data-visible="true"]
      document.querySelector(".HeaderH1").classList.add("Score");
      setButtonsInteractable(false);
      if (matchSequence.gameTemplate.buttonsUseLotties === true) {
        matchSequence.gameTemplate.buttonsUseLotties && sequenceButtons.current.forEach((sequenceButton, index) => {
          if (sequenceButton.name === userSequence[userSequence.length - 1]) {
            sequenceButtons.current[index].playSegments([onMissSegmentStart, onMissSegmentEnd], true);
          }
        });
      }
      document.getElementById('game-pads').setAttribute('data-fadeout', true);
    }
    return () => {
      if (matchSequence.gameTemplate.buttonsUseLotties === true) {
        matchSequence.gameTemplate.buttonsUseLotties && sequenceButtons.current.forEach(sequenceButton => {
          setTimeout(() => {
            // lottieButton.remove();
            sequenceButton.destroy();
          }, 1750);
        });
      }
    };
  }, [missed]);


  return (
    <section
      className="game section-game simone-said game-play"
      data-removed={gamePadsRemoved}
      aria-atomic="false" 
      // aria-live="polite"
      >
      {/* 
      @2DO: Set to respect config: useCountdownOverlay
      {(showCountDown && matchSequence.gameTemplate.enableCountDown) &&
        <Countdown 
          showCountDown={showCountDown} 
          onFinish={() => setShowCountDown(false)} 
          countDownAnimation={countDownAnimation}
          setCountDownAnimation={setCountDownAnimation}
          soundEffects={soundEffectsRef}
        />
      } */}
      {/* 
      @2DO: Set to respect config: debugMode 
      {
        <p id="debug-text">{currentCueMetadata?.id}</p>
      }
      {
      // @2DO: Set to respect config: useSpriteComponent
          // clicks.map((click) => 
          //     <SparkAnimation 
          //         key={click.id} 
          //         x={click.x} 
          //         y={click.y} 
          //         imageData={
          //             click.variant === 'px' ? imageDataPx :
          //             click.variant === 'py' ? imageDataPy :
          //             imageDataPz
          //         }
          //         variant={click.variant}
          //         position={click.position}
          //     />
          // )
      }
      {/* <button id="startGameBtn" onClick={(event) => {initGame(gameTemplate)}}>Start Game</button> */}
      
      {/* <p id="debug-text">{currentCueMetadata?.id}</p> */}
      <div className="tutorial-copy-container" aria-atomic="false" aria-live="polite">
        <HeaderH1 ariaHidden={false} textValue={currentH1}/>
        {/* <h1 className='HeaderH1'>{currentH1}</h1> */}
        <div className="tutorial" data-showtutorial="false">
          <h1 data-text-stroke={tutorialContentMain}>
            {tutorialContentMain}
          </h1>
          <div className="tutorial-axe" data-showtutorialaxe="false">
            <h2>
              {tutorialContentAxe}
            </h2>
          </div>
        </div>      
      </div>

      {
        streakHeader &&
          <div className={`streakText-container ${fadeOut ? 'fade-out' : ''}`}>
            <div className={`streakText level-${gameLevel}-streak`}  data-alt={streakHeader}>
            <span tabIndex="0" >{streakHeader}</span>
          </div>
        </div>
      }
      <div
        id="game-pads"
        className="level-selection-nav"
        >
        {/* @2DO: We should not be sharing the styles from the level-select page, modularize this properly so they can both use a shared naemspace */}
        <ul className={`level-selection-list level-selection-list--two-columns`}>
        {buttonIcons.map((buttonIcon, index) => (
            <li 
            key={index} 
            className="level-selection-list-item">
              <button className="pad"
                // primary-cta-btn cta-btn level-btn 
                // key={buttonIcon.alt}
                data-position={index}
                data-character={buttonIcon.alt.replace(/\s/g, '').toLowerCase()}
                onClick={(buttonsInteractable) => {
                  buttonsInteractable && 
                  handlePadClick(buttonIcon.alt, index); 
                }}
                onKeyDown={(event) => {
                  // @2DO: Try using disabled prop instead of pointer-events 
                    console.log(event);
                    if (event.keyCode === 32 || event.keyCode === 13) {
                      event.preventDefault();
                      if (event.target.attributes['data-position'].value === buttonCurrentlyInteractable) {
                        handlePadClick(buttonIcon.alt, index);
                      } else {
                        console.log('Keyboard input blocked by – button uninteractable');
                      }
                    }
                }}
                tabIndex={0}
                aria-label={buttonIconsTranslated[index].alt}
              >
                <img src={buttonIconsTranslated[index].icon} alt="" />
                <span className="cta-btn-txt level-btn-sprite-image-container">
                  {/* @2DO: NOTE: This is going to get ugly fast with all the conditions – consider a component */}
                  { matchSequence.gameTemplate.buttonsUseLotties && <span className={`lottie-button${index+1} lottie-button ${buttonIconsTranslated[index].alt}`} ></span>}
                  { matchSequence.gameTemplate.buttonsUseLotties === false && <span className={`pad-button-${index+1} pad-button ${buttonIconsTranslated[index].alt}`}>{buttonIconsTranslated[index].label}</span>}
                </span>
              </button>
            </li>
            ))}
        </ul>
      </div>
     {(gamePadsRemoved !== true) && <AriaLiveAnnoucer id="screenAnnouncer" />}
     {(urlParams.get('testing') === 'true') && 
      <div className="debug-game"   
        style={{ display: "block"}}  
      >
          <div id="skipToGameover"
          onClick={() => {
            console.log('GAME: SKIP: GAME_OVER');
            // updateVieConfig({
            //   // skipChapter:  "TRIGGER_GAMEPLAY_ALL-OUT"
            //   skipChapter:  "TRIGGER_GAMEPLAY-EXIT"
            // });
            handleMiss();
          }
          }
          style={{
          fontSize: '3rem',
          color: 'white',
          // display: 'none',
          }}
          >
          END GAME
        </div>
        <div id="skipToEnd"
          onClick={() => {
            console.log('GAME: SKIP: GAME_END');
            updateVieConfig({
              // skipChapter:  "TRIGGER_GAMEPLAY_OVER"
              skipChapter: "CHAPTER_COMPLETION"
            });
          }
          }
          style={{
          fontSize: '3rem',
          color: 'white',
          display: 'none',
          }}
          >
          SKIP TO EGG
        </div>
        <div id="skipToGame"
          onClick={() => {
            console.log('GAME: SKIP: GAME_END');
            initGame(matchSequence.gameTemplate);
            updateVieConfig({
              // skipChapter:  "TRIGGER_GAMEPLAY_OVER"
              skipChapter: "CHAPTER_COUNTDOWN"
            });
          }
          }
          style={{
          fontSize: '3rem',
          color: 'white',
          // display: 'none',
          }}
          >
          SKIP TO GAME
        </div>
      </div>}

       </section>
  );
};

// Game.whyDidYouRender = true;

export default Game;

